import { Box, Paper, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import type { TicketComment } from "../services/ticketService";
import { displayName, formatDateTime } from "../utils/display";
import { UserAvatar } from "./UserAvatar";

export function TicketActivity({ comments }: { comments: TicketComment[] }) {
  const { t, i18n } = useTranslation();
  if (!comments.length) {
    return (
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        {t("tickets.noActivity")}
      </Typography>
    );
  }

  return (
    <Stack spacing={0} sx={{ mb: 3 }}>
      {comments.map((comment, index) => {
        const name =
          comment.authorType === "SYSTEM"
            ? t("authors.SYSTEM")
            : displayName(undefined, comment.authorEmail, t(`authors.${comment.authorType}`));
        const last = index === comments.length - 1;
        return (
          <Box key={comment.id} sx={{ display: "flex", gap: 1.5, position: "relative", pb: last ? 0 : 2 }}>
            {!last ? (
              <Box
                sx={{
                  position: "absolute",
                  left: 17,
                  top: 36,
                  bottom: 0,
                  width: 2,
                  bgcolor: "divider",
                }}
              />
            ) : null}
            <UserAvatar email={comment.authorEmail} authorType={comment.authorType} size={36} />
            <Paper sx={{ flex: 1, p: 1.5 }}>
              <Stack direction="row" justifyContent="space-between" gap={1} flexWrap="wrap">
                <Typography fontWeight={700}>{name}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {formatDateTime(comment.createdDate, i18n.language)}
                </Typography>
              </Stack>
              <Typography variant="caption" color="text.secondary">
                {t(`authors.${comment.authorType}`)}
              </Typography>
              <Typography sx={{ mt: 0.75, whiteSpace: "pre-wrap" }}>{comment.body}</Typography>
            </Paper>
          </Box>
        );
      })}
    </Stack>
  );
}
